import React,{useState} from 'react';
import { Link, useParams } from 'react-router-dom';
import FundraisersStory from './FundraisersStory';

const FundraisersRouting = () => {
    // const params = useParams()
    
    const [nestedRoutes] = useState([
        "Story",
        "Parks",
        "Team",
        "FAQ",
        "Discussion",
        "Updates"
    ]);
    const [ activeMenu, setActiveMenu ] = useState(0)
    const selectedBtn = (index) =>{
        setActiveMenu(index)
    }
    // console.log(para)
    return (
        <div className="col-12">
            <div className="row">
                <div className="d-flex justify-content-between align-items-center gap-4 mb-4 custom-overflow-controler  py-3 py-lg-0">
                    {
                        // custm-pill-button-small
                        nestedRoutes.map(( item, index ) => <span  className={activeMenu === index ? `tab_fund custm-pill-button-small cursor-pointer`: `tab_fund cursor-pointer`}  key={index} onClick={ () => selectedBtn(index)} >{item}</span>)
                    }
                    {/* <span className="tab_fund custm-pill-button-small">Story</span>
                    <div className="px-5 py-1 rounded-pill  custm-pill-button-small cursor-pointer">
                        <span className="px-3 activetab_fund">Perks</span>
                    </div>
                    <span className="tab_fund custm-pill-button-small">Team</span>
                    <span className="tab_fund custm-pill-button-small">FAQ</span>
                    <span className="tab_fund custm-pill-button-small">Discussion</span>
                    <span className="tab_fund custm-pill-button-small">Updates</span> */}
                    {/* <Link>Story</Link>
                    <Link>Perks</Link>
                    <Link>Team</Link>
                    <Link>FAQ</Link>
                    <Link>Discussion</Link>
                    <Link>UPdates</Link> */}
                    {/* <Link to={`/fundraisers/details/${params?.id}/story`} className={  `tab_fund cursor-pointer text-decoration-none` }>Story</Link>
                    <Link to={`/fundraisers/details/${params?.id}/perks`} className='tab_fund cursor-pointer text-decoration-none'>perks</Link>
                    <Link to={`/fundraisers/details/${params?.id}/team`}  className='tab_fund cursor-pointer text-decoration-none'>team</Link>
                    <Link to={`/fundraisers/details/${params?.id}/faq`}  className='tab_fund cursor-pointer text-decoration-none'>faq</Link>
                    <Link to={`/fundraisers/details/${params?.id}/discussion`}  className='tab_fund cursor-pointer text-decoration-none'>discussion</Link>
                    <Link to={`/fundraisers/details/${params?.id}/updates`}  className='tab_fund cursor-pointer text-decoration-none'>updates</Link> */}
                </div>
            </div>
                {
                    activeMenu === 0 ? <FundraisersStory /> : activeMenu === 1 ? "Parks" : activeMenu === 2 ? "Team" : activeMenu === 3 ? "FAQ" :  activeMenu === 4 ? "Discussion" :  activeMenu === 5 ? "Updates" : ''
                }
        </div>
    );
};

export default FundraisersRouting;